module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    attrs: {
      "src": _vm.pictureUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('div', [_c('p', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.displayName))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('form', {
    staticClass: "sidebar-form",
    attrs: {
      "id": "searchForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-success"
  }), _vm._v(" Online\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group",
    attrs: {
      "id": "searchContainer"
    }
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('input', {
    staticClass: "search form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "data-toggle": "hideseek",
      "p": "",
      "laceholder": "Search Menus",
      "data-list": ".sidebar-menu"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-390144f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Sidebar.vue
// module id = 416
// module chunks = 1